<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <g>
    <g>
      <rect class="cls-5" x="33.59" y="33.59" width="2.47" height="41.82"/>
      <rect class="cls-5" x="53.13" y="34.6" width="2.47" height="41.82"/>
    </g>
    <g>
      <rect class="cls-5" x="17.31" y="45.48" width="54.57" height="2.47"/>
      <rect class="cls-5" x="17.31" y="62.12" width="54.57" height="2.47"/>
    </g>
    <g>
      <path class="cls-4" d="m70.65,29.69v5.2H18.55v-5.2c0-3.61,2.97-6.58,6.61-6.58h38.88c3.64,0,6.61,2.97,6.61,6.58Z"/>
      <path class="cls-4" d="m71.88,36.13H17.31v-6.44c0-4.31,3.52-7.82,7.85-7.82h38.88c4.33,0,7.85,3.51,7.85,7.82v6.44Zm-52.1-2.47h49.62v-3.96c0-2.95-2.41-5.35-5.37-5.35H25.16c-2.96,0-5.37,2.4-5.37,5.35v3.96Z"/>
    </g>
    <path class="cls-4" d="m64.04,76.42H25.16c-4.33,0-7.85-3.51-7.85-7.82v-34.95h54.57v34.95c0,4.31-3.52,7.82-7.85,7.82ZM19.79,36.13v32.47c0,2.95,2.41,5.35,5.37,5.35h38.88c2.96,0,5.37-2.4,5.37-5.35v-32.47H19.79Z"/>
    <g>
      <path class="cls-3" d="m34.11,28.2c-1.37,0-2.47-1.11-2.47-2.47v-6.32c0-1.37,1.11-2.47,2.47-2.47s2.47,1.11,2.47,2.47v6.32c0,1.37-1.11,2.47-2.47,2.47Z"/>
      <path class="cls-3" d="m55.09,28.2c-1.37,0-2.47-1.11-2.47-2.47v-6.32c0-1.37,1.11-2.47,2.47-2.47s2.47,1.11,2.47,2.47v6.32c0,1.37-1.11,2.47-2.47,2.47Z"/>
    </g>
  </g>
  <g>
    <circle class="cls-1" cx="64.24" cy="69.49" r="11.7"/>
    <path class="cls-2" d="m64.24,82.26c-7.04,0-12.77-5.73-12.77-12.77s5.73-12.77,12.77-12.77,12.77,5.73,12.77,12.77-5.73,12.77-12.77,12.77Zm0-23.4c-5.86,0-10.63,4.77-10.63,10.63s4.77,10.63,10.63,10.63,10.63-4.77,10.63-10.63-4.77-10.63-10.63-10.63Z"/>
  </g>
  <path class="cls-4" d="m64.02,76.77c-.95,0-1.87-.15-2.78-.44-.9-.29-1.63-.67-2.19-1.15l1-2.38c1.22.89,2.52,1.34,3.9,1.34.77,0,1.37-.19,1.8-.57.43-.38.64-.89.64-1.53s-.21-1.17-.62-1.57c-.41-.39-.97-.59-1.68-.59-1.02,0-1.88.39-2.6,1.16h-2.03v-8.85h9.07v2.58h-6.04v3.21c.66-.43,1.46-.65,2.4-.65s1.7.19,2.38.58c.68.39,1.21.92,1.59,1.62.38.69.57,1.49.57,2.4,0,.96-.22,1.8-.65,2.52-.43.72-1.06,1.28-1.87,1.69-.81.41-1.78.61-2.89.61Z"/>
</svg>
</template>

<script>
export default {
    name: "YearTrendlineIcon",
}
</script>

<style scoped>
      .cls-1 {
        fill: #fff;
      }

      .cls-2 {
        fill: #0f5b71;
      }

      .cls-3 {
        fill: #0c5f74;
      }

      .cls-4 {
        fill: #59c5c7;
      }

      .cls-5 {
        fill: #b6dfcf;
      }
    </style>